import Vue from 'vue'
import Vuex from 'vuex'

import { auth } from './auth'
import { user } from './user'
import { app } from './app'
import { patient } from './patient'
import { device } from './device'

const debug: boolean = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app: {
      ...app
    },
    auth: {
      namespaced: true,
      ...auth
    },
    user: {
      namespaced: true,
      ...user
    },
    patient: {
      namespaced: true,
      ...patient
    },
    device: {
      namespaced: true,
      ...device
    }
  },
  strict: debug
})
